import { Fragment } from "react";
import { CartonQRCodeBank, ProductQRCodeBank } from "./components";

const QRCodeBank = () => {
  return (
    <Fragment>
      <ProductQRCodeBank />
      <CartonQRCodeBank />
    </Fragment>
  );
};

export default QRCodeBank;
